import { readerPages } from "@/mocks/readerPages";

export function getChapterPages(chapterIndex: number): string[] {
  const count = 6;
  const start = (chapterIndex * 3) % readerPages.length;
  const result: string[] = [];
  for (let i = 0; i < count; i += 1) {
    result.push(readerPages[(start + i) % readerPages.length]);
  }
  return result;
}